import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import {
    CommonFilterModel,
    CommonPaginatorResourceService,
    CommonParams
} from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

export class PaginatorDynamicDatasource<T> extends PaginatorDatasource<T> {
    protected readonly _url: string

    constructor(service: CommonPaginatorResourceService<T>, url: string) {
        super(service)
        this._url = url
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        return this.service.paginator(filterModel, params, this._url)
    }
}
